import type { OneTimeOrderLine, OneTimeOrderProduct } from '../components/subscription-detail/OneTimeOrderModal';

// Turns a subscription's items into one-time order lines, priced from the product list.
// Subscription items carry a SKU prefix, e.g. '25FID6 – 2025 Fiano'.
export function subscriptionItemsToOrderLines(items: {
  name: string;
  quantity: number;
}[], products: OneTimeOrderProduct[]): OneTimeOrderLine[] {
  return items.map((item, index) => {
    const productName = item.name.split(' – ').pop()?.trim() ?? item.name;
    const product = products.find(p => p.name === productName);
    return {
      id: product?.id ?? `item-${index}`,
      name: productName,
      price: product?.price ?? 0,
      quantity: item.quantity
    };
  });
}
